import axios from "axios";

const http = axios.create({
  baseURL:
    process.env.VUE_APP_BASE_URL !== undefined
      ? process.env.VUE_APP_BASE_URL + "/api/user"
      : "/api/user",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Currency": localStorage.getItem("optionCurrency")
      ? localStorage.getItem("optionCurrency")
      : "THB"
  },
  timeout: 5000
});
http.interceptors.request.use(
  config => {
    let _auth = localStorage.getItem("_auth");
    if (_auth && _auth != "bnVsbA==" && _auth != "undefined") {
      config.headers.Authorization = "Bearer " + _auth;
    }
    return config;
  },
  err => {
    console.log(err);
  }
);
export default http;
